const SvgOperatingSystems1 = (props) => (
  <>
    <defs />
    <circle cx={192} cy={192} r={192} stroke="#042068" strokeWidth="3px" fill="none" strokeMiterlimit={10} />
    <path
      d="M192 188V48M223.54 101.3C261.07 114.35 288 150.03 288 192c0 53.02-42.98 96-96 96s-96-42.98-96-96c0-41.71 26.6-77.21 63.76-90.45"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={192} cy={192} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={192} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgOperatingSystems1;
